import { SvgIcon, SvgIconProps } from '@mui/material';
import styles from './ccf-copilot-suggestion-icon.module.scss';

/* eslint-disable-next-line */
export interface CcfCopilotSuggestionIconProps extends SvgIconProps {
  fillColor?: string;
}

/**
 * Component used to display copilot suggestion icon
 * @param props - CcfCopilotSuggestionIconProps
 * @returns
 * @example
 */
export function CcfCopilotSuggestionIcon(props: CcfCopilotSuggestionIconProps) {
  return (
    <SvgIcon width="13" height="13" viewBox="0 0 13 13" fill="none" {...props}>
      <path
        d="M3.10753 7.59028L5.15117 6.5686V6.56848C5.76441 6.26186 6.26162 5.76468 6.56824 5.15145L7.59042 3.10751C7.65753 2.97342 7.79464 2.88867 7.94468 2.88867C8.09461 2.88867 8.23184 2.97342 8.29894 3.10751L9.32078 5.15108C9.62729 5.76431 10.1246 6.2615 10.7377 6.56811L12.781 7.59025C12.9152 7.65724 13 7.79447 13 7.94451C13 8.09455 12.9152 8.23166 12.781 8.29875L10.7374 9.32056C10.1242 9.62706 9.62694 10.1244 9.32044 10.7375L8.2986 12.781C8.23149 12.9152 8.09426 13 7.94434 13C7.79429 13 7.65718 12.9152 7.59008 12.781L6.56824 10.7375C6.26161 10.1243 5.76441 9.62705 5.15117 9.32056L3.10753 8.29842C2.97356 8.23119 2.88892 8.0942 2.88892 7.94429C2.88892 7.79438 2.97356 7.6574 3.10753 7.59028ZM3.36337 2.75644L4.23914 2.31791C4.29657 2.28913 4.33273 2.23049 4.33273 2.16629C4.33273 2.10209 4.29657 2.04345 4.23914 2.01467L3.36337 1.57664C3.10051 1.44521 2.88747 1.23217 2.75604 0.969318L2.31798 0.0935815C2.28921 0.0361493 2.23057 0 2.16636 0C2.10216 0 2.04351 0.0361524 2.01474 0.0935815L1.57669 0.969318C1.44526 1.23217 1.23221 1.44521 0.96935 1.57664L0.0935843 2.01467C0.0361503 2.04345 0 2.10209 0 2.16629C0 2.23049 0.0361534 2.28914 0.0935843 2.31791L0.969474 2.75582L0.969353 2.75594C1.23222 2.88725 1.44539 3.10041 1.57669 3.36314L2.01474 4.239C2.04352 4.29643 2.10216 4.33258 2.16637 4.33258C2.23057 4.33258 2.28921 4.29643 2.31799 4.239L2.75592 3.36314V3.36326C2.88735 3.10041 3.10052 2.88737 3.36338 2.75607L3.36337 2.75644Z"
        
      />
    </SvgIcon>
  );
}

export default CcfCopilotSuggestionIcon;
